import React, { Component, Fragment } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { properties } from '../../../constants/Propertise';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import DashboardTiles from './DashboardTiles';
import { Row, Col, Card, CardHeader, Button, Alert } from 'reactstrap';


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <Fragment>
                <ReactCSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}
                >
                    <div>
                        <PageTitle
                            heading={properties.myDashboardText}
                            doActions={this.openAddHPModel}
                            downloadReport=""
                            showButton={false}
                            downloadData={[]}
                            headers=""
                            fileName=""
                        />
                        <Fragment>
                            <Row>
                                <Col md="12">
                                    <DashboardTiles />
                                </Col>
                            </Row>
                        </Fragment>
                    </div>
                </ReactCSSTransitionGroup>

            </Fragment>
        )
    }
}

export default Dashboard;